import useAuth, { STEP } from "./useAuth";
import dynamic from "next/dynamic";
import { Suspense } from "react";

const Next = dynamic(() => import("./Next"), {
  suspense: true,
});

const Register = dynamic(() => import("./Register"), {
  suspense: true,
});

const Login = dynamic(() => import("./Login"), {
  suspense: true,
});

const Steps = () => {
  const { step, onNext, email, onLogin, onRegister } = useAuth();

  return (
    <div className="w-full h-full">
      {step === STEP.NEXT ? (
        <>
          <Suspense
            fallback={
              <>
                <p>Loading...</p>
              </>
            }
          >
            <Next onLogin={onLogin} onNext={onNext} />
          </Suspense>
        </>
      ) : step === STEP.REGISTER ? (
        <>
          <Suspense
            fallback={
              <>
                <p>Loading...</p>
              </>
            }
          >
            <Register onLogin={onLogin} email={email} />
          </Suspense>
        </>
      ) : (
        <>
          <Suspense
            fallback={
              <>
                <p>Loading...</p>
              </>
            }
          >
            <Login onRegister={onRegister} />
          </Suspense>
        </>
      )}
    </div>
  );
};

export default Steps;
